<div class="modal-header modal-header-no-banner" id="clear-history-modal">
      <h3 class="modal-title">Clear history?</h3>
</div>
<div class="modal-body container-fluid">
  This will clear your search history and remove any data in your cart.
</div>

<div class="modal-footer">
    <div class="pull-left">
      <button class="btn btn-primary btn-ciprs" (click)="clearHistory()" id="clear-history-clear-button">Clear</button>
      <button class="btn btn-primary btn-ciprs" (click)="hideModal()" id="clear-history-dont-clear-button">Don't clear</button>
    </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/clear-history/clear-history.component.html